import { apiClient } from './api/client';
import { AuthUser } from '../types/auth';
import { UserProfile } from '@/types/users';

type AuthenticatedUser = AuthUser;

export const userService = {
  // Buscar perfil completo do usuário
  async getProfile(): Promise<AuthenticatedUser> {
    const response = await apiClient.get<AuthenticatedUser>('/auth/profile');
    return response.data;
  },

  // Atualizar perfil do usuário
  async updateProfile(data: Partial<AuthenticatedUser>): Promise<AuthenticatedUser> {
    const response = await apiClient.patch<AuthenticatedUser>('/auth/profile', data);
    return response.data;
  },

  // Buscar desenvolvedores
  async getDevelopers(): Promise<UserProfile[]> {
    const response = await apiClient.get<UserProfile[]>('/employees/developers');
    return response.data;
  },
};
